<template>
<div class="container index-container" name="container" >
      <div class="cover">
        <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(image, index) in WX_H5_BNCRS.imageUrl" :key="index" @click="routeToAdsPage(WX_H5_BNCRS, index)">
              <img v-lazy="image.imageUrl" />
            </van-swipe-item>
        </van-swipe>
      </div>
    
      <div class="keybor"> <keyboard></keyboard></div>

      <!-- <div class="tips">
        <h5>温馨提示:</h5>
        <p><router-link to="/subscribe" class="router">关注</router-link>、<router-link to="/register" class="router">注册</router-link>并<span>绑定车牌后</span>以后即可免费体验以下功能;</p>
        <p>入场通知，出场通知，停车通知，缴费通知等。</p>
      </div> -->
      <!-- 广告模块 -->
      <!-- <div class="ads-container index-ads" v-if="WX_H5_QP.imageUrl">
        <div class="ads-wrapper" @click="routeToAdsPage(WX_H5_QP)">
          <div class="ads-cover"></div>
          <span class="ads-flag">广告</span>
          <van-icon class="ads-close" name="cross" size="22px" color="red" @click="handleCloseAd(WX_H5_QP)" />
          <img :src="WX_H5_QP.imageUrl" alt="">
        </div>
      </div> -->

</div>
</template>
<script>
  import { Row, Col, Icon } from 'vant'
  import Keyboard from './keyboard'
  import { Swipe, SwipeItem } from 'vant';
  import { AD_URL } from "@/assets/api"
  export default {
    name:"container",
    data() {
      return {
        ads: ['WX_H5_QP', 'WX_H5_BNCRS'],
        WX_H5_QP: {
          apiUrl: AD_URL + '?bCommid=00000165&ads=WX_H5_QP',
          browserType: 'wx',
          type: 'WX_H5_QP',
          adUrl: '',
          imageUrl: '',
        },
        WX_H5_BNCRS: {
          apiUrl: AD_URL + '?bCommid=00000165&ads=WX_H5_BNCRS',
          type: 'WX_H5_BNCRS',
          browserType: 'wx',
          imageUrl: [
            { adUrl: '', imageUrl: require('../../../static/images/banner_1.jpg')},
            { adUrl: '', imageUrl: require('../../../static/images/banner_2.jpg')},
            { adUrl: '', imageUrl: require('../../../static/images/banner_3.jpg')},
          ],
        },
      }
    },
    components: {
      Keyboard,
      [Row.name]: Row,
      [Col.name]: Col,
      // [Lazyload.name]: Lazyload,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Icon.name]: Icon,
    },
    methods:{
      routeToAdsPage(ad, index){
        this.commonUtil.routeToAdsPage(ad, index)
      },
      handleCloseAd(ad){
        ad.adUrl = ''
        ad.imageUrl = ''
      },
    },
    created(){

    },
    mounted() {
      if(this.$route.path.indexOf("tempPay") > -1){
        sessionStorage.setItem("backPage","tempPay");
      }
      // this.ads.forEach(el => {
      //   this.commonUtil.getAds(this[el])
      // });
    }
  };
</script>
<style lang="less">

  .van-swipe-item img{
    width:100%;
    height: 100%;
  }
  .van-swipe{
    height: 166px;
  }
  .user-links img{
    width: 28px;
  }
  #es{
    width: 24px;
  }
  .menu{
    padding: 10px 0;
    background: white
  }
  .menu_img{
    height: 34px;
  }
  .menu p{
    color:rgb(51,51,51)
  }
  .container .van-swipe__indicator {
      background-color: #fff;
  }
  .index-container{
      height: 100vh;
      background: #fff;
      box-sizing: border-box;
      position: relative;
  }
  .tips{
    width: 92%;
    margin: 0 auto;
    text-align: left;
    h5{
      font-size: 14px;
      line-height: 16px;
      vertical-align: middle;
    }
    p{
      font-size: 12px;
      line-height: 16px;
      vertical-align: middle;
      .router{
        color: #dd001b;
        font-weight: bold;
        text-decoration: underline;
      }
      span{
        color: #4585f5;
        font-weight: bold;
      }
    }
  }

  @keyframes fadeIn {
      0% {
          opacity: 0;
          transform: translate(0, 20px);
      }
      100% {
          opacity: 1;
          transform: translate(0, 0);
      }
  }
  .ads-container{
    .ads-wrapper{
      margin: 0 auto;
      position: relative;
      
      animation-name: fadeIn;
      animation-duration: 1.5s;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
      opacity: 0;
      img{
        display: block;
        max-width: 100%;
      }
      .ads-cover{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }
      .ads-flag{
        display: block;
        font-weight: bold;
        color: #ff0000;
        font-size: 14px;
        line-height: 18px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .ads-close{
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    &.index-ads{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 12%;
      height: 100px;
      .ads-wrapper{
        width: 92%;
        height: 100%;
        margin: 0 auto;
        position: relative;
        opacity: 0;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/index/index.vue